import { dispatch } from 'store/'
import { actionTypes } from '../../config'

export const dispatchComments = (comments) => {
    return dispatch({type: actionTypes.FETCH_COMMENTS, payload: comments} )
}